import React from 'react';

const FIELDS = [
  { name: 'name', label: 'Full Name', type: 'text', placeholder: 'Enter your name' },
  { name: 'email', label: 'Email', type: 'email', placeholder: 'your@email.com' },
  { name: 'phone', label: 'Phone Number', type: 'tel', placeholder: '+91 98765 43210' },
];

const CustomerDetailsForm = ({ customerDetails, onChange }) => (
  <div
    className="network-card p-8"
    data-testid="checkout-customer-details-form"
  >
    <h2 className="text-2xl font-bold text-white mb-6">Your Details</h2>
    <div className="space-y-4">
      {FIELDS.map((field) => (
        <div key={`checkout-field-${field.name}`}>
          <label
            htmlFor={`checkout-${field.name}`}
            className="block text-text-secondary mb-2"
          >
            {field.label} *
          </label>
          <input
            id={`checkout-${field.name}`}
            type={field.type}
            name={field.name}
            value={customerDetails[field.name]}
            onChange={onChange}
            className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:border-brand-primary focus:outline-none"
            placeholder={field.placeholder}
            required
            data-testid={`checkout-input-${field.name}`}
          />
        </div>
      ))}
    </div>
  </div>
);

export default CustomerDetailsForm;
